import { apiClient } from './client';
import { HuntStatsResponse } from '@gps-hunt/shared';

/**
 * Get hunt statistics
 */
export async function getHuntStats(huntId: string): Promise<HuntStatsResponse> {
  const response = await apiClient.get<HuntStatsResponse>(`/hunts/${huntId}/stats`);

  if (!response.success || !response.data) {
    throw new Error(response.error?.message || 'Failed to load statistics');
  }

  return response.data;
}

export const statsService = {
  getHuntStats,
};
